import React from 'react';

export const cooperationModelsData = [
	{
		icon: '/images/icons/dedicated-team-icon.svg',
		title: 'Dedicated Team',
		content: (
			<p>
				A Dedicated Team is selected according to the client&#8217;s defined needs.
				The team works exclusively for you on a full-time basis and is priced at
				a monthly flat rate.
			</p>
		),
		url: 'dedicated-team/',
	},
	{
		icon: '/images/icons/staff-augmentation-icon.svg',
		title: 'Staff Augmentation',
		content: (
			<p>
				It is an outsourcing model that lets you augment your existing team with
				external developers. Staff Augmentation could be the fastest option to
				reinforce your project team.
			</p>
		),
		url: 'staff-augmentation/',
	},
	{
		icon: '/images/icons/weekly-sprints-orange.svg',
		title: 'Time & Material',
		content: (
			<p>
				The Time and Material model is an excellent choice if you want to create
				the best team possible with a wide range of skills. The project manager
				will oversee the entire endeavor and assemble the ideal specialists.
			</p>
		),
		url: 'time-and-material/',
	},
	{
		icon: '/images/icons/fixed-price-icon.svg',
		title: 'Fixed-price trial',
		content: (
			<p>
				The fixed-price model is only a trial version. This model will be
				accurate when you want to make a small piece of the project.
			</p>
		),
		url: 'fixed-price/',
	},
];
